import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import AnnouncementTicker from '../AnnouncementTicker/AnnouncementTicker';
import ImpersonationBanner from '../ImpersonationBanner/ImpersonationBanner';
import ReadOnlyBanner from '../ReadOnlyBanner/ReadOnlyBanner';
import Breadcrumb from '../Breadcrumb/Breadcrumb';
import ErrorBoundary from '../ErrorBoundary/ErrorBoundary';
import GlobalSearch from '../GlobalSearch/GlobalSearch';
import KeyboardShortcuts from '../KeyboardShortcuts/KeyboardShortcuts';
import MobileNav from '../MobileNav/MobileNav';
import SessionTimeout from '../SessionTimeout/SessionTimeout';
import { useSystemName } from '../../hooks/useSystemName';
import { settingsApi } from '../../services/api';
import './Layout.css';

function Layout() {
  // This hook will set the document title dynamically
  useSystemName();

  const [trainingMode, setTrainingMode] = useState(false);

  useEffect(() => {
    settingsApi.getTrainingMode()
      .then(res => setTrainingMode(res.data.enabled))
      .catch(() => {});
  }, []);

  return (
    <div className={`layout${trainingMode ? ' training-mode' : ''}`}>
      <Header />
      <ReadOnlyBanner />
      <ImpersonationBanner />
      <AnnouncementTicker />
      <main className="main-content">
        <div className="container">
          <Breadcrumb />
          <ErrorBoundary>
            <Outlet />
          </ErrorBoundary>
        </div>
      </main>
      <Footer />
      <MobileNav />
      <GlobalSearch />
      <KeyboardShortcuts />
      <SessionTimeout />
    </div>
  );
}

export default Layout;
